import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Tenants")
const _hoisted_2 = {
  key: 0,
  class: "d-flex flex-column gap-5"
}
const _hoisted_3 = { class: "w-100 bg-white p-5" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "ms-3 text-capitalize" }
const _hoisted_6 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_TenantAvatar = _resolveComponent("TenantAvatar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "agency-container" }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    subtitle: _withCtx(() => [
      _createTextVNode("Found " + _toDisplayString(_ctx.table.total) + " tenants", 1)
    ]),
    default: _withCtx(() => [
      (!_ctx.table.items.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_skeleton, {
                animated: "",
                row: "5"
              })
            ])
          ]))
        : (_openBlock(), _createBlock(_component_DataTable, {
            key: 1,
            "table-data": _ctx.table.items,
            "table-header": _ctx.tableHeaders,
            "enable-items-per-page-dropdown": true,
            "row-class": "table-hover",
            "onClick:row": _ctx.viewTenant
          }, {
            "cell-name": _withCtx(({ row: item }) => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_router_link, {
                  to: {
              name: 'view-tenant-details',
              params: { tenant_id: item.id },
            },
                  class: "d-flex align-items-center",
                  style: {"color":"inherit !important"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_TenantAvatar, {
                      name: item.name,
                      radius: true,
                      id: item.user.id,
                      style: {"margin-right":"15px"}
                    }, null, 8, ["name", "id"]),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(item.first_name) + " " + _toDisplayString(item.last_name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ]),
            "cell-rating": _withCtx(({ row: item }) => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_form_item, { class: "mb-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_rate, {
                      class: "rating-size",
                      "model-value": 1,
                      disabled: "",
                      max: "1"
                    })
                  ]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(parseFloat(item.average_rating).toFixed(1)), 1)
              ])
            ]),
            "cell-submitted_reference_count": _withCtx(({ row: item }) => [
              _createTextVNode(_toDisplayString(item.submitted_reference_count), 1)
            ]),
            "cell-signed_up_date": _withCtx(({ row: item }) => [
              _createTextVNode(_toDisplayString(_ctx.formatDate(item.signed_up_date)), 1)
            ]),
            "cell-referred": _withCtx(({ row: item }) => [
              (item.referred_id)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: {
            name: 'view-agency',
            params: { agent_id: item.referred_id },
          },
                    class: "d-flex align-items-center",
                    style: {"color":"inherit !important"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.referred), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["table-data", "table-header", "onClick:row"]))
    ]),
    _: 1
  }))
}